// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  '***': {
    '***': [
      {
        metric: 11,
        inHeader: true,
        label: 'Branded OfferPi Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'Branded Offer KPIs',
        rowType: 'h0'
      },
      {
        metric: 12,
        label: 'Appeal',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Consideration (Likely to Switch)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 14,
        label: 'Likely to Contact Provider to Learn More',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Likely to Purchase',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Other Specific Attribute Performance - Branded',
        rowType: 'h0'
      },
      {
        metric: 16,
        label: 'Better than Current Package',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 17,
        label: 'Fulfills a need',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 18,
        label: 'Good Value for the Money',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Is Believable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Unique from other offers',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 1,
        inHeader: false,
        label: 'Unbranded OfferPi Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'Other Offer KPIs',
        rowType: 'hb0'
      },
      {
        label: 'Unbranded Offer KPIs',
        rowType: 'h0'
      },
      {
        metric: 2,
        label: 'Appeal',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Consideration (Likely to Switch)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 4,
        label: 'Likely to Contact Provider to Learn More',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Likely to Purchase',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },

      {
        label: 'Headline Evaluation',
        rowType: 'hb0'
      },
      {
        label: 'Unbranded Headline KPIs',
        rowType: 'h0'
      },
      {
        metric: 38,
        label: 'Appeal',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 21,
        label: 'Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 39,
        label: 'Learn More',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Headline Descriptors: Postive',
        rowType: 'h0'
      },
      {
        metric: 40,
        label: 'Clear',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 41,
        label: 'New & Different',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 42,
        label: 'Memorable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 43,
        label: 'Fulfills a Need',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 44,
        label: 'Honest',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Headline Descriptors: Negative',
        rowType: 'h0'
      },
      {
        metric: 45,
        label: 'Vague',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 46,
        label: 'Seen it Before',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 47,
        label: 'Forgettable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 48,
        label: 'Not Necessary',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 49,
        label: 'Too Good to be True',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      // {
      //   metric: 22,
      //   label: 'Believable',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 23,
      //   label: 'Unique',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 24,
      //   label: 'Attention-grabbing',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 25,
      //   label: 'Clear',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 26,
      //   label: 'Informative',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   label: 'Postive Features',
      //   rowType: 'h0'
      // },
      // {
      //   metric: 27,
      //   label: 'Price',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 28,
      //   label: 'Contract terms',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 29,
      //   label: 'Perk/Benefits',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 30,
      //   label: 'Other',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   label: 'Negative Features',
      //   rowType: 'h0'
      // },
      // {
      //   metric: 31,
      //   label: 'Price',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 32,
      //   label: 'Contract terms',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 33,
      //   label: 'Perk/Benefits',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 34,
      //   label: 'Other',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      {
        label: 'Branded Headline+Offer KPIs',
        rowType: 'h0'
      },
      {
        metric: 35,
        label: 'Accurately Describes Offer',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Impact',
        rowType: 'hb0'
      },
      {
        label: 'Impact on Offer',
        rowType: 'h0'
      },
      {
        metric: 50,
        label: 'Improves impression (Net)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 51,
        label: 'Greatly Improves impression of offer',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 52,
        label: 'Somewhat Improves impression of offer',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 53,
        label: 'No Impact',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 54,
        label: 'Worsens impression offer',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Impact on Provider',
        rowType: 'h0'
      },
      {
        metric: 55,
        label: 'Improves impression (Net)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 56,
        label: 'Greatly Improves impression of provider',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 57,
        label: 'Somewhat Improves impression of provider',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 58,
        label: 'No Impact',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 59,
        label: 'Worsens impression of provider',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      // {
      //   metric: 36,
      //   label: 'Impact on Consideration',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 37,
      //   label: 'Impact on Overall Impression',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   label: 'Other Specific Attribute Performance',
      //   rowType: 'h0'
      // },
      // {
      //   metric: 6,
      //   label: 'Better than Current Package',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 7,
      //   label: 'Fulfills a need',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 8,
      //   label: 'Good Value for the Money',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 9,
      //   label: 'Is Believable',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   metric: 10,
      //   label: 'Unique from other offers',
      //   rowType: 'd0',
      //   dataFormat: '%,1',
      //   reverseStat: false
      // },
      // {
      //   label: 'Impact of Brand',
      //   rowType: 'hb0'
      // },

      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/scorecard/MetricsLabels/metricsLabels.js